import React, { useContext, useState } from "react";
import Popover from "../Popover";
import { Counter } from "../Counter";
import NotificationList from "./NotificationList";
import { NotificationsContext } from "../../context";
import NotificationCard from "./NotificationCard";
import { NewNotification } from "./styles";
import Icon from "../Icon";

const Notification = () => {
  const notificationContext = useContext(NotificationsContext);

  const [active, setActive] = useState(false);

  const [newNotification, setNewNotification] = useState({
    dismissed: false,
    value: null
  });
  const dismissNewNotification = () => {
    setNewNotification(prev => ({
      value: prev.value,
      dismissed: true
    }));
  };
  const latestNotification = notificationContext.notifications.reduce(
    (n1, n2) => (n1?.created_at > n2?.created_at ? n1 : n2),
    null
  );

  if (
    latestNotification !== null &&
    (newNotification.value == null ||
      newNotification.value?.id !== latestNotification?.id) &&
    Date.now() - latestNotification?.created_at < 6000
  ) {
    setNewNotification({
      value: latestNotification,
      dismissed: false
    });
    setTimeout(dismissNewNotification, 6000);
  }

  const notificationIcon = (
    <div
      style={{ position: "relative", cursor: "pointer" }}
      onClick={() => {
        dismissNewNotification();
        setActive(prev => !prev);
      }}
    >
      <Icon type="bell" size="lg" color="#DEDEDE" label="notifications" />
      {!active && notificationContext.unread > 0 && (
        <Counter>
          <p className="p4b text"> {notificationContext.unread}</p>
        </Counter>
      )}
    </div>
  );

  const newNotificationPopup = (
    <NewNotification>
      <div className="blueShrink"></div>

      <div className="innerNotification">
        <NotificationCard
          onClick={() => {
            notificationContext.readNotification(
              notificationContext.notifications,
              newNotification.value.id
            );
            dismissNewNotification();
          }}
          notification={newNotification.value}
        />
      </div>
    </NewNotification>
  );

  return (
    <>
      {newNotification &&
        newNotification.dismissed === false &&
        newNotification.value &&
        newNotificationPopup}
      <Popover
        fixed
        top="80px"
        right="50px"
        triggerComponent={notificationIcon}
        dropdown={<NotificationList onClose={() => setActive(false)} />}
        showDropdown={active}
        onClose={() => setActive(false)}
      />
    </>
  );
};

export default Notification;
